import config from "../../config";
import getVar from "../../core-module/tiny-functions/getVar";
import { Plugins } from "@capacitor/core";
import { isIosDevice } from "../../deviceInfo";
const { Browser } = Plugins;

const redirect = async function () {
  let rc = Number(getVar("rc"));
  rc = isNaN(rc) ? 0 : rc;
  rc++;

  const oldRP = "" + window.location.pathname + "";
  const newRP = oldRP.replace(config.MYACCOUNT.APP_PATH, "");
  const rp = encodeURIComponent("" + newRP + "");

  const hw = getVar("hw");
  const seg = getVar("seg");

  const queryArray = [];
  queryArray.push("r=" + config.AUTH.REDIRECT_PARAM);
  queryArray.push("rc=" + rc);
  queryArray.push("rp=" + rp);

  if (hw !== false) {
    queryArray.push("hw=" + hw);
  }
  if (seg !== false) {
    queryArray.push("seg=" + seg);
  }
  if (rc <= 5) {
    const isIos = await isIosDevice();

    if (isIos) {
      await setTimeout(function () {
        Browser.open({
          url:
            config.AUTH.ADDRESS +
            config.AUTH.APP_PATH +
            "?route=logout&r=" +
            config.AUTH.REDIRECT_PARAM,
        });
      }, 2000);

      Browser.addListener("browserFinished", (data) => {
        window.location.replace(config.MYACCOUNT.APP_PATH + "/will/logout");
        return;
      });
    } else {
      window.location.replace(
        [config.AUTH.ADDRESS + config.AUTH.APP_PATH, queryArray.join("&")].join(
          "?",
        ),
      );
    }
  } else {
    throw new Error("Too many redirects");
  }

  return;
};

export default redirect;
